import {Record} from 'immutable';
import Color from '~/data/records/Color';
import {findColorByRgb, INK_COLORS} from '~/constants/InkConstants';

export default class SpotColor extends Record({
  original: INK_COLORS.Black,
  palette: INK_COLORS.Black,
  user: INK_COLORS.Black,
  selectedUser: INK_COLORS.Black
}) {
  constructor({original, palette, user}) {
    const originalColor =
      original && (original instanceof Color ? original : new Color(original));
    const paletteColor =
      palette &&
      (palette.transparent ? INK_COLORS.None : findColorByRgb(palette));
    const userColor =
      user && (user.transparent ? INK_COLORS.None : findColorByRgb(user));
    super(
      {
        original: originalColor,
        palette: paletteColor,
        user: userColor || paletteColor,
        selectedUser: userColor || paletteColor
      },
      'SpotColor'
    );
  }
}
